import React from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "../../components/layout/DashboardLayout";

const NAV = [
  { to: "/super-admin",               label: "Dashboard",      icon: "▦",  end: true },
  { to: "/super-admin/organisations", label: "Organisations",  icon: "🏛️" },
  { to: "/super-admin/facilities",    label: "Facilities",     icon: "🏥" },
  { to: "/super-admin/users",         label: "Users",          icon: "👥" },
  { to: "/super-admin/branding",      label: "Branding",       icon: "🎨" },
];

export default function SuperAdminLayout() {
  return (
    <DashboardLayout navItems={NAV} sectionLabel="Super Admin">
      <Outlet />
    </DashboardLayout>
  );
}
